import { hexColor } from '@/lib/decor'
import styles from './ServerTag.module.css'

interface Props {
  tag: string
  color: number
  className?: string | undefined
}

/** Тег сервера рядом с ником: цветной квадратик и 2–4 буквы, как «ВЕЧ». */
export function ServerTag({ tag, color, className }: Props) {
  return (
    <span className={className ? `${styles.tag} ${className}` : styles.tag} data-tooltip={`Тег сервера «${tag}»`}>
      <span className={styles.swatch} style={{ background: hexColor(color) }} aria-hidden="true" />
      {tag}
    </span>
  )
}
